import React, { useRef,useEffect } from 'react'
function useOutsideAlerter(ref, props) {
  let onClickOutside = props.onClickOutside
  let eventListener = props.eventListener || 'mousedown'
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      onClickOutside && onClickOutside(event)
      document.removeEventListener(eventListener, handleClickOutside)
    }
  }
  useEffect(() => {
    document.addEventListener(eventListener, handleClickOutside)
    return () => {
    }
  })
}
export default function OutsideAlerter(props) {
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef, props)

  return <div ref={wrapperRef} onClick={props.onClickOutside} data-test="outsideContent">{props.children}</div>
}